export default __webpack_public_path__ + "static/media/2-logos_low-code.7844af7b.webp";